export default __webpack_public_path__ + "images/models/b982f21493bad0d3d513310e77045d5d.glb";